import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Compass, ChevronDown, Lock } from "lucide-react";
import api from "@/lib/api";
import { SaidSections } from "@/components/gauge/ReflectionView";
import { EntryAnswers } from "@/components/gauge/JourneyEntryDetail";

const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); } catch { return ""; } };

// GAUGE explorations clients have explicitly chosen to share with this enhancer.
export default function SharedGauge() {
  const { data = [] } = useQuery({ queryKey: ["enh-gauge-shared"], queryFn: () => api.get("/enhancer/me/gauge-shared").then((r) => r.data) });
  const [open, setOpen] = useState(null);
  return (
    <section className="space-y-3" data-testid="enh-gauge-shared">
      <h3 className="font-serif text-xl text-[#1A242B] flex items-center gap-2"><Compass size={18} className="text-[#D98E73]" /> GAUGE reflections shared with you</h3>
      <p className="text-xs text-[#4A5D6B] flex items-center gap-1.5"><Lock size={12} /> Clients choose what to share and can stop anytime. Please treat these as their words, not a diagnosis.</p>
      {data.length === 0 ? <p className="text-sm text-[#8FA89B]" data-testid="enh-gauge-shared-empty">No client has shared a GAUGE exploration with you yet.</p> : data.map((e) => (
        <div key={e.id} className="eyw-card p-5" data-testid={`enh-gauge-${e.id}`}>
          <button onClick={() => setOpen(open === e.id ? null : e.id)} aria-expanded={open === e.id} className="w-full flex items-center justify-between text-left">
            <span><b className="text-[#1A242B]">{e.member_name}</b> <span className="text-sm text-[#4A5D6B]">· {e.path_title} · {fmt(e.created_at)}</span></span>
            <ChevronDown size={16} className={`transition-transform ${open === e.id ? "rotate-180" : ""}`} />
          </button>
          {open === e.id && (
            <div className="mt-4 space-y-4">
              {e.member_reflection && (
                <div className="text-sm text-[#4A5D6B] space-y-1">
                  {e.member_reflection.intention && <p><b className="text-[#1A242B]">Their intention:</b> {e.member_reflection.intention}</p>}
                  {e.member_reflection.chosen_next_step && <p><b className="text-[#1A242B]">Their next step:</b> {e.member_reflection.chosen_next_step}</p>}
                  {e.member_reflection.correction && <p><b className="text-[#1A242B]">Their correction:</b> {e.member_reflection.correction}</p>}
                </div>
              )}
              {e.reflection?.said && <SaidSections said={e.reflection.said} />}
              {(e.followups || []).length > 0 && (
                <div><p className="text-sm font-semibold text-[#1A242B]">Their follow-ups</p>
                  {e.followups.map((f) => <p key={f.id} className="text-sm text-[#4A5D6B] mt-1">{fmt(f.created_at)}: {[f.tried, f.happened, f.helped, f.adjust].filter(Boolean).join(" · ")}</p>)}
                </div>
              )}
              <details><summary className="text-sm text-[#144F75] cursor-pointer">All answers</summary><div className="mt-2"><EntryAnswers entry={e} /></div></details>
            </div>
          )}
        </div>
      ))}
    </section>
  );
}
